import * as React from 'react';
import Loader from '../../../Components/Loader';
import { Modal } from '../../../Components/Modal';
import { AdminIcon } from '../../../Icons/AdminIcon';
import { RecipientService } from '../../../DataService/RecipientService';
import '../AdminGroups.css';

interface AddUserToGroupModalProps {
  groupName: string;
  isSaving: boolean;
  onAdd: (email: string) => Promise<void>;
  onClose: () => void;
}

export const AddUserToGroupModal = ({
  groupName,
  isSaving,
  onAdd,
  onClose
}: AddUserToGroupModalProps) => {
  const [email, setEmail] = React.useState("");
  const [search, setSearch] = React.useState("");
  const [recipients, setRecipients] = React.useState<{ id: string; name: string; email: string }[]>([]);

  React.useEffect(() => {
    RecipientService.getUsers().then((data) => setRecipients(data ?? []));
  }, []);

  const filteredRecipients = recipients.filter((recipient) => {
    const query = search.trim().toLowerCase();
    if (!query) return true;
    return recipient.name.toLowerCase().includes(query) || recipient.email.toLowerCase().includes(query);
  });

  return (
    <Modal className="admin-group-modal-layout" onClose={onClose}>
      <div className="admin-group-modal-close">
        <button type="button" aria-label="Stäng" onClick={onClose}>
          <AdminIcon.CrossClose fill="hsl(var(--primary))" width={18} />
        </button>
      </div>

      <div className="sheet-header-container">
        <h2 className="sheet-header-text">Lägg till medlem</h2>
        <p className="sheet-header-paragraph">
          Välj en befintlig medlem eller skriv en egen e-postadress för <strong>{groupName}</strong>.
        </p>
      </div>

      <div className="admin-group-modal-form">
        <label className="block-text-sm-font-medium-text-gray-700-mb-1">Sök medlem</label>
        <input
          className="admingroups-input admin-group-modal-recipient-search"
          placeholder="Sök namn eller e-post"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />

        <div className="admin-group-modal-recipient-list">
          {filteredRecipients.length === 0 ? (
            <p className="admin-group-modal-help-text">Inga matchande medlemmar.</p>
          ) : (
            filteredRecipients.map((recipient) => (
              <button
                type="button"
                key={recipient.id}
                className={`admin-group-modal-recipient-item ${email === recipient.email ? 'active' : ''}`}
                onClick={() => setEmail(recipient.email)}
              >
                <span>
                  <strong>{recipient.name}</strong>
                  <small>{recipient.email}</small>
                </span>
                <span>Välj</span>
              </button>
            ))
          )}
        </div>

        <label className="block-text-sm-font-medium-text-gray-700-mb-1">Emailadress</label>
        <input
          className="admingroups-input"
          placeholder="user@example.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
      </div>

      <div className="admin-group-modal-footer">
        <button
          type="submit"
          className="sheet-form-submit-button"
          onClick={() => onAdd(email)}
          disabled={!email || isSaving}
        >
          {isSaving ? (
            <>
              <Loader loaderSize="SMALL" bgColor="white" /> Lägger till...
            </>
          ) : (
            <>
              <AdminIcon.PlusSign width={16} height={16} fill="white" />
              Lägg till medlem
            </>
          )}
        </button>
      </div>
    </Modal>
  );
};
